import axios from 'axios'
import Vue from 'vue'
import {requestUrl} from '../utils/requestConfig'
import { getStore, removeStore } from '/utils/storage'

/* axios.defaults.timeout = 10000
axios.defaults.baseURL = requestUrl.url
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded' */

const service = axios.create({
  baseURL: requestUrl.url,
  timeout: requestUrl.timeout
})

service.interceptors.request.use(
  /**
   * 请求拦截器，在请求之前做配置
   */
  config => {
    config.headers['Content-Type'] = 'application/json'
    // if (store.getters.token) {
    //     config.headers['Authorization'] = 'Bearer ' + getToken()
    // }
    if (getStore('token')) {
      config.headers['Authorization'] = 'Bearer ' + getStore('token')
    }
    return config
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  /**
   * 响应拦截器，在请求之前做配置
   */
  response => {
    const res = response.data
    if (response.data.code === 504) {}

    if (response.data.status === 401) {
      // 跳到登录页面
      // Vue.prototype.$message.warning('请先登录')
      // router.go(-1)
      // removeStore('token')
    }
    return res
  },
  error => {
    //console.log('err' + error.response)
    // 失败响应
    // if (err && err.response) {
    // switch (err.response.status) {
    //   case 400:
    //     err.message = '请求无效，请检查参数是否正确!'
    //     break

    //   case 401:
    //     err.message = '未经授权，访问被拒!'
    //     break

    //   case 403:
    //     err.message = '拒绝访问!'
    //     break

    //   case 404:
    //     err.message = `地址不存在!`
    //     break

    //   case 408:
    //     err.message = '请求超时!'
    //     break

    //   case 500:
    //     err.message = '系统错误!'
    //     break

    //   case 501:
    //     err.message = '该方法未实现!'
    //     break

    //   case 502:
    //     err.message = '网管出错!'
    //     break

    //   case 503:
    //     err.message = '服务不可用!'
    //     break

    //   case 504:
    //     err.message = '网关请求超时'
    //     break

    //   case 505:
    //     err.message = 'HTTP版本不受支持'
    //     break

    //   default:
    // }
    // if (err.response.data.error) {
    //   err.message = err.response.data.error
    // }
    // Vue.prototype.$message.closeAll()
    // Vue.prototype.$message.error(err.message)

    // 401无token
    if (error.response.data.status === 401) {
      /* store.dispatch('user/resetToken').then(() => {
        location.reload()
      }) */
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js